import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import api, { setAuth } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Shield, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      setAuth(r.data.access_token, r.data.user);
      toast.success(`Benvenuto, ${r.data.user.nome}`);
      if (r.data.user.role === "admin") nav("/admin");
      else nav("/admin/dj");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore di login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Header showAdminLink={false} />
      <main className="max-w-md mx-auto px-6 py-20">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-14 h-14 rounded-xl flex items-center justify-center bg-orange-500/10 border border-orange-500/30 text-orange-300">
            <Shield className="w-7 h-7" />
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-white/40">Area riservata</div>
            <h1 className="text-3xl font-black tracking-tight">Login</h1>
          </div>
        </div>

        <form
          onSubmit={submit}
          className="bg-[#0E0E11] border border-white/10 rounded-2xl p-7 space-y-5"
          style={{ borderTop: "4px solid #FF5722" }}
        >
          <div>
            <Label className="text-xs uppercase tracking-wider text-white/60">Email</Label>
            <Input
              data-testid="admin-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 bg-black/60 border-white/10 text-white"
              required
            />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider text-white/60">Password</Label>
            <Input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 bg-black/60 border-white/10 text-white"
              required
            />
          </div>
          <Button
            type="submit"
            data-testid="admin-login-btn"
            disabled={loading}
            className="w-full h-12 rounded-full font-bold tracking-widest text-white border-0 bg-gradient-to-r from-[#FF5722] to-[#00E5FF]"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "ACCEDI"}
          </Button>
        </form>
      </main>
    </div>
  );
}
